import { UFOExperience } from '@atlassian/ufo-experimental/experience';
import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
} from '@atlassian/ufo-experimental/experience-types';

const keyToTiming = (key: string) => ({
	key,
	startMark: `${key}_start`,
	endMark: `${key}_end`,
});

const timings = ['FetchedActivities', 'TransformedActivityItems', 'GeneratedQueryWithFilters'].map(
	keyToTiming,
);

export const recentWorkClientExperienceV2 = (): UFOExperience => {
	return new UFOExperience('client', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.Custom,
		platform: { component: 'recent-work' },
		timings,
	});
};
export const recentWorkClientExperienceV3 = (): UFOExperience =>
	new UFOExperience('client-v3', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.Custom,
		platform: { component: 'recent-work' },
		timings,
	});
